import {FC} from "react";
import {Typography} from "antd";
import {TitleProps} from "antd/es/typography/Title";

type Props = {
    value?: string;
    onChange?: (value: string) => void;
    onTouched?: VoidFunction;
} & TitleProps;

export const TitleFormItem: FC<Props> = ({ value, onChange, onTouched, ...rest }) => {
    const handleChange = (value: string) => {
        onTouched?.();
        onChange?.(value);
    }

    return (
        <Typography.Title
            {...rest}
            editable={{ onChange: handleChange }}
        >{value}</Typography.Title>
    )
}